export const getPackLength = (value?: string | null): number => {
  if (!value) return 0

  return value.split(',').length
}
